import { fmtINR, fmtNum, fmtRate } from "@/lib/format";
import { MetricTable, SectionHead } from "./MetricTable";

const int = (v) => fmtNum(v, 0);
const lagFmt = (v) => (v === null || v === undefined ? "—" : `${fmtNum(v)}d`);

const SETTER_COLS = [
  { key: "dials", label: "Dials/DMs", fmt: int },
  { key: "conversations", label: "Conversations", fmt: int },
  { key: "conv_to_booked_pct", label: "Conv→Booked", fmt: fmtRate },
  { key: "speed_to_lead_min", label: "Speed to Lead (min)", fmt: (v) => fmtNum(v) },
  { key: "booking_lag_days", label: "Booking Lag", fmt: lagFmt },
  { key: "calls_scheduled", label: "Calls Scheduled", fmt: int },
  { key: "calls_taken", label: "Calls Taken", fmt: int },
  { key: "declined_to_book", label: "Declined to Book", fmt: int },
  { key: "declined_offer", label: "Declined Offer", fmt: int },
  { key: "cancels", label: "Cancels", fmt: int },
  { key: "no_shows", label: "No-Shows", fmt: int },
  { key: "show_up_rate_pct", label: "Show-Up Rate", fmt: fmtRate },
  { key: "dq_rate_pct", label: "DQ Rate", fmt: fmtRate },
];

const CLOSER_COLS = [
  { key: "calls_taken", label: "Calls Taken", fmt: int },
  { key: "offers", label: "Offers", fmt: int },
  { key: "sales", label: "Sales", fmt: int },
  { key: "offer_rate_pct", label: "Offer Rate", fmt: fmtRate },
  { key: "close_rate_pct", label: "Close Rate", fmt: fmtRate },
  { key: "close_on_offers_pct", label: "Close on Offers", fmt: fmtRate },
  { key: "one_call_sales", label: "1-Call Sales", fmt: int },
  { key: "follow_up_sales", label: "Follow-Up Sales", fmt: int },
  { key: "avg_deal_size", label: "Avg Deal Size", fmt: fmtINR },
  { key: "revenue_per_call", label: "Revenue / Call", fmt: fmtINR },
];

export const SetterTable = ({ data }) => (
  <section data-testid="setter-section">
    <SectionHead title="Setters" sub="Activity by activity date; lead metrics by Date Created. Booking lag above 4 days is a leak." />
    <MetricTable prefix="setter" firstLabel="Setter" columns={SETTER_COLS} rows={data.setters} total={data.setter_total} />
  </section>
);

export const CloserTable = ({ data }) => (
  <section data-testid="closer-section">
    <SectionHead title="Closers" sub="Calls Taken = Show or Declined. Revenue / Call = Cash Collected ÷ Calls Taken." />
    <MetricTable prefix="closer" firstLabel="Closer" columns={CLOSER_COLS} rows={data.closers} total={data.closer_total} />
  </section>
);
